import getDialogByType from './get-dialog-by-type';
import getDialogOptions from './get-dialog-options';

export default {
  getDialogByType,
  getDialogOptions,
};
